// internal action types
export const FETCH_WORKER_APPLICATIONS = "FETCH_WORKER_APPLICATIONS";
export const GET_ALL_WORKERS = "GET_ALL_WORKERS";
export const ADD_NEW_WORKER = "ADD_NEW_WORKER";
export const FETCH_CURRENT_WORKER = "FETCH_CURRENT_WORKER";
export const UPDATE_WORKER = "UPDATE_WORKER";
export const DELETE_WORKER = "DELETE_WORKER";
export const GET_INTERMEDIARY_COMPANY = "GET_INTERMEDIARY_COMPANY";
export const DELETE_WORKER_CV = "DELETE_WORKER_CV";
export const DELETE_WORKER_COMPLIANCE_DOC = "DELETE_WORKER_COMPLIANCE_DOC";

// external action types
export const NS_FETCH_WORKER_APPLICATIONS = "workers/FETCH_WORKER_APPLICATIONS";
export const NS_GET_ALL_WORKERS = "workers/GET_ALL_WORKERS";
export const NS_ADD_NEW_WORKER = "workers/ADD_NEW_WORKER";
export const NS_UPDATE_WORKER = "workers/UPDATE_WORKER";
export const NS_DELETE_WORKER = "workers/DELETE_WORKER";
